// For tickets
export function printTickets(tickets, travelBaseUrl, contentId) {
    if (!tickets || tickets.length === 0) return;
    const ticketIds = tickets.map((ticket) => ticket.id).join(",");
    const url = `${travelBaseUrl}/CMSTemplates/VivaTravelASPX/data/common/theater-ticket.ashx?g=${contentId}&t=${ticketIds}`;
    window.open(url, "_self");
}

// For products
export function printProducts(products, tellerBaseUrl, contentId) {
    if (!products || products.length === 0) return;
    const productIds = products.map((product) => product.id).join(",");
    const url = `${tellerBaseUrl}/data/pub/products.ashx?orderId=${contentId}&productId=${productIds}`;
    window.open(url, "_self");
}